import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img5.png';
const _hoisted_1 = {
  class: "container-fluild long-container"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "long-row flex justify-around align-center"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "from"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createStaticVNode("<div class=\"title\" data-v-3c873e5a>浙江鹤立运营科技有限公司</div><div data-v-3c873e5a><div class=\"info\" data-v-3c873e5a>地点：浙江省金华市婺城区四联路398号</div><div class=\"info\" data-v-3c873e5a>邮编：321000</div><div class=\"info\" data-v-3c873e5a>电话：0579-82391818</div><div class=\"info\" data-v-3c873e5a>邮箱：562389817@QQ.COM</div></div>", 2)), _createElementVNode("div", _hoisted_5, [_cache[1] || (_cache[1] = _createTextVNode(" COPYRIGHT (@) 2023 浙江鹤立运营科技有限公司 ", -1)), _createElementVNode("span", {
    style: {
      "margin-left": "10px",
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.toContact && $setup.toContact(...args))
  }, "浙ICP备17036550号-8")])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "right"
  }, [_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "200px",
      "height": "200px"
    },
    alt: ""
  }), _createElementVNode("div", {
    style: {
      "margin-top": "22px"
    }
  }, " 品浙消费微信公众号 ")], -1))])])]);
}